module.exports = __webpack_public_path__ + "static/media/logo-mospi-7.5c585d86.png";